var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.242 1.172h-.703V0h-1.172v1.172H3.633V0H2.46v1.172h-.703A1.76 1.76 0 0 0 0 2.93v10.312C0 14.212.789 15 1.758 15h11.484A1.76 1.76 0 0 0 15 13.242V2.93a1.76 1.76 0 0 0-1.758-1.758zm.586 12.07a.587.587 0 0 1-.586.586H1.758a.587.587 0 0 1-.586-.586V5.508h12.656v7.734zm0-8.906H1.172V2.93c0-.323.263-.586.586-.586h.703v1.172h1.172V2.344h7.734v1.172h1.172V2.344h.703c.323 0 .586.263.586.586v1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.227 6.738h1.172V7.91H2.227zM4.57 6.738h1.172V7.91H4.57zM6.914 6.738h1.172V7.91H6.914zM9.258 6.738h1.172V7.91H9.258zM11.602 6.738h1.172V7.91h-1.172zM2.227 9.082h1.172v1.172H2.227zM4.57 9.082h1.172v1.172H4.57zM6.914 9.082h1.172v1.172H6.914zM9.258 9.082h1.172v1.172H9.258zM2.227 11.426h1.172v1.172H2.227zM4.57 11.426h1.172v1.172H4.57zM6.914 11.426h1.172v1.172H6.914zM9.258 11.426h1.172v1.172H9.258zM11.602 9.082h1.172v1.172h-1.172z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.81a0b579b44e01710fe72d17f04ffe07.svg";
export { ForwardRef as ReactComponent };